var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRowContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2501 15C14.6641 15 15.0001 15.336 15.0001 15.75C15.0001 16.164 14.6641 16.5 14.2501 16.5H1.7501C1.3361 16.5 1.0001 16.164 1.0001 15.75C1.0001 15.336 1.3361 15 1.7501 15H14.2501ZM22.2485 7.49838C22.6625 7.49838 22.9985 7.83438 22.9985 8.24838C22.9985 8.66238 22.6625 8.99838 22.2485 8.99838H1.74854C1.33454 8.99838 0.998535 8.66238 0.998535 8.24838C0.998535 7.83438 1.33454 7.49838 1.74854 7.49838H22.2485ZM18.2501 0C18.6641 0 19.0001 0.336 19.0001 0.75C19.0001 1.164 18.6641 1.5 18.2501 1.5H1.7501C1.3361 1.5 1.0001 1.164 1.0001 0.75C1.0001 0.336 1.3361 0 1.7501 0H18.2501Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowContent);
export default __webpack_public_path__ + "static/media/rowContent.bd91f5a6e904524717df2a0691dadaf8.svg";
export { ForwardRef as ReactComponent };